import SecurityService from "../services/security.service";

export const security = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    toEncrypt({ commit }, str) {
      var bodyFormData = new FormData();
      bodyFormData.append('originStr', str)

      return SecurityService.toEncrypt(bodyFormData).then(
        (resp) => {
          commit("dummy", "toEncrypt - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "toEncrypt - error");
          return Promise.reject(error.response);
        }
      );
    },
    toDecrypt({ commit }, encryptedStr) {
      var bodyFormData = new FormData();
      bodyFormData.append('encryptedStr', encryptedStr)
      return SecurityService.toDecrypt(bodyFormData).then(
        (resp) => {
          commit("dummy", "toDecrypt - success");
          return Promise.resolve(resp);
        },
        (error) => {
          commit("dummy", "toDecrypt - error");
          return Promise.reject(error.response);
        }
      );
    },
  },
  mutations: {
    dummy(state, obj) {
      console.log(obj);
    },
    dummyConsole(state, obj) {
      console.log(obj);
    },
  },
};
